var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TenantConfirm"),
      _vm._v(" "),
      _c("ECircularContact", {
        ref: "eCircularContact",
        attrs: {
          companyId: _vm.companyId,
          tenancyId: _vm.tenancyId,
          allowLinkContacts: _vm.allowLinkContacts,
          linkFunc: _vm.linkFunc,
        },
      }),
      _vm._v(" "),
      _c("EmergencyContact", {
        ref: "emergencyContact",
        attrs: {
          companyId: _vm.companyId,
          tenancyId: _vm.tenancyId,
          allowLinkContacts: _vm.allowLinkContacts,
          linkFunc: _vm.linkFunc,
        },
      }),
      _vm._v(" "),
      _c("FireMarshalContact", {
        ref: "fireMarshalContact",
        attrs: {
          allowLinkContacts: _vm.allowLinkContacts,
          linkFunc: _vm.linkFunc,
        },
      }),
      _vm._v(" "),
      _vm.isRetail
        ? _c("MarketingContact", {
            ref: "marketingContact",
            attrs: {
              tenancyId: _vm.tenancyId,
              allowLinkContacts: _vm.allowLinkContacts,
              linkFunc: _vm.linkFunc,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("OthersContact", {
        attrs: {
          companyId: _vm.companyId,
          tenancyId: _vm.tenancyId,
          allowLinkContacts: _vm.allowLinkContacts,
          linkFunc: _vm.linkFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }